<template>
  <div class="aui-content">
    <div class="aui-content maui-info-textbox">
      <h2 style="  text-align: center;">{{title}}</h2>
      <div style="float:left;margin-left:7px;display:inline; padding-top:7px">文章来源：{{copyfrom}}</div>
      <div style="padding-top:5px;float:right;padding-right:4px;">{{createDate}}</div>
      <br />
      <div class="aui-content maui-info-textbox">
        <div class="battery-s-code"><img src="/static/image/article_header.jpg" alt= /></div>
      </div>
      <div class="maui-textbox">
        <div class="battery-detail-cctoe" v-html="content">{{content}}</div>
      </div>
      <div class="aui-content maui-info-textbox">
        <div class="battery-s-code"><img src="/static/image/article_footer.jpg" alt= /></div>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: "ScrollerOne",
  data() {
    return {
      //noDate: false,//这是一个判断是否加载的开关
      arr: [],
      showPage: 1,
      pageSize: 4,
      xqid: "",
      id: "",
      content: "",
      goodsClassName: "",
      pictureUrl: "",
      createDate: "",
      speciDetailList: "",
      copyfrom: "",
      estimatedPrice: "",
      title: "",
      number: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.xqid = this.$route.query.xqid;
      // Axios.get('http://gank.io/api/data/%E7%A6%8F%E5%88%A9/5/1').then((response) => {
      //http://gank.io/api/data/%E7%A6%8F%E5%88%A9/' + that.pageSize + '/' + that.showPage
      this.$axios
        .get(
          "/micro/permission_order-view/article/read/articleInfo?id=" +
            this.xqid +
            ""
        )
        .then(res => {
          console.log(res);
          this.id = res.data.data.id;
          //  this.createDate=res.data.data.createDate
          this.createDate = this.$moment(res.data.data.createDate).format(
            "YYYY-MM-DD"
          );
          this.arr = res.data.data.data;
          this.copyfrom = res.data.data.copyfrom;
          this.content = res.data.data.content;
          // let newContent = this.content.replace(
          //   /\<img/gi,
          //   '<img style="max-width:100%;height:100px!important;display:block;"'
          // );
          // console.log(newContent);
          console.log("_+_+_+_+_+" + this.copyfrom);
          this.title = res.data.data.title;
        })
        .catch(error => {
          console.log(error);
          //没网的时候，或者接口调用异常的时候
          // this.$refs.myscroller.finishInfinite(true);//这个方法是不让它加载了，显示“没有更多数据”，要不然会一直转圈圈
        });
    }
  }
};
</script>
 
<style scoped>
.container {
  display: flex;
  width: 375px;
  height: 100%;
  /* background: red; */
  flex-direction: column;
}
.battery-article-rapper {
  padding: 20px;
}
.itemStyle {
  display: flex;
  width: 375px;
  height: 100px;
  /* background: coral;
    border: 1px blue solid; */
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/newsDetail.vue